$(document).ready(function() {
    $(".ui.dropdown").dropdown();
    $(".Menu_Close").click(function() {
        $(".ui.sidebar").sidebar("hide");
    });
    $(".MenuToggler").click(function() {
        $(".ui.sidebar").sidebar("show");
    });

    $(".sidebar a").click(function() {
        $(".ui.sidebar").sidebar("hide");
    });
    var content = [
        {
            title: "Andorra",
            url: "/home"
        },
        {
            title: "United Arab Emirates"
        },
        {
            title: "Afghanistan"
        },
        {
            title: "Antigua"
        },
        {
            title: "Anguilla"
        }
    ];
    $(".ui.search").search({
        source: content,
        onSelect(content) {
            window.location.href = content.url;
        }
    });
});
